//export const AnswerType = {
//    ListBox: 1,
//    Radio: 4,
//    Integer: 5,
//    TextBox: 10,
//    Postcode: 15,
//    DatePicker: 35
//}

export const AnswerType = {
    ListBox: 1,
    Radio: 4,
    Integer: 5,
    TextBox: 3,
    Postcode: 15,
    DatePicker: 2,
    RadioSelect: 40,
    NativeSelect: 41
}